import { ReactComponent as CloseCrossIcon } from '@Icons/additional/close-cross.svg';
import { ReactComponent as CheckIcon } from '@Icons/additional/check.svg';
import { MButton } from '@Components/Base';

import styles from './column-header.module.css';

interface ColumnHeaderProps {
  isAllSelected: boolean;
  count: number;
  onApprove?: () => void;
  onReject?: () => void;
}

const ColumnHeader: React.FC<ColumnHeaderProps> = ({
  isAllSelected,
  count,
  onApprove,
  onReject,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {isAllSelected && 'All'}
        <span className={styles.textBold}>{count} REQUESTS</span> ON THIS PAGE
        ARE SELECTED
      </div>
      <div className={styles.actions}>
        <MButton
          type="text"
          icon={<CheckIcon />}
          className={styles.action}
          onClick={onApprove}
        >
          Approve
        </MButton>
        <div className={styles.divider} />
        <MButton
          type="text"
          icon={<CloseCrossIcon />}
          className={styles.action}
          onClick={onReject}
        >
          Reject
        </MButton>
      </div>
    </div>
  );
};

export default ColumnHeader;
